import { createUseStyles } from '@glu/theming';

const styles = ({ breakpoints, typography }) => ({
  snack: {
    position: 'fixed',
    zIndex: '3',
    bottom: '15px',
    right: '15px',
    background: 'rgba(0,0,0,0.9)',
    maxWidth: '550px',
    minWidth: '344px',
    color: '#ffffff',
    padding: '16px',
    boxSizing: 'border-box',
    boxShadow: '1px 1px 5px rgba(0,0,0,0.2)',
    fontFamily: typography.fontFamily,
    [`@media only screen and (max-width: ${breakpoints.values.sm}px)`]: {
      left: '15px',
      right: '15px'
    },
    '& > p': {
      margin: '0'
    },
    borderLeft: '5px solid #00dfeb',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    '& > *': {
      flex: '1'
    }
  },
  longStyle: {
    flexBasis: '100%',
    textAlign: 'right'
  },
  errorStyle: {
    borderLeft: '5px solid #f15a24'
  }
});

export default createUseStyles(styles);
